import { Box } from "@mui/material";
import BlurOption from "./BlurOption";
import { NoneOption } from "./widgets";
import { useSelectedEffectedVideoTrack } from "../contexts/videoEffectContext";
import { Video } from "@dvrt/web-phone-client";

const VideoBackgroundEffectDialogContent = () => {
    const track = useSelectedEffectedVideoTrack();

    if (!track) return null;

    return (
        <Box sx={{ display: "flex" }}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "1em",
                }}
            >
                <NoneOption />
                <BlurOption level={"light"} />
                <BlurOption level={"strong"} />
            </Box>
            <Video
                track={track}
                style={{
                    width: 400,
                    transform: "scaleX(-1)",
                }}
            />
        </Box>
    );
};

export default VideoBackgroundEffectDialogContent;
